export default __webpack_public_path__ + "static/media/DMXmemory_01.e0206e0f.webp";